<template>
  <div class="absolute bottom-0 left-0 z-50">
    <button class="flex items-center justify-center w-16 h-16 opacity-0" @dblclick="toggleSettings">
      <SettingsIcon class="text-white" />
    </button>
  </div>
  <div v-show="active" class="absolute top-0 left-0 z-50 w-full bottom-12 xl:bottom-16">
    <div class="absolute inset-0 bg-black bg-opacity-70" @click="active = false" />
    <div class="relative w-full h-full max-w-screen-sm bg-white">
      <button class="absolute z-10 top-8 right-8" @click="active = false">
        <XIcon />
      </button>
      <div id="settings" class="relative h-full">
        <div class="p-16 space-y-4">
          <h1 class="inline-flex text-4xl font-bold text-primary-500">ตั้งค่า</h1>

          <div class="">
            <h2 class="mb-2 text-lg font-bold">การตั้งค่าทั่วไป</h2>

            <div class="">
              <table class="w-full overflow-hidden">
                <tr>
                  <td class="w-4/5">แสดงรายละเอียดยูนิต</td>
                  <td class="w-1/5 text-center"><input v-model="showUnitInfo" type="checkbox" checked></td>
                </tr>
                <tr>
                  <td class="w-4/5">แสดงราคาในรายละเอียดยูนิต</td>
                  <td class="w-1/5 text-center"><input v-model="showPrice" type="checkbox" checked></td>
                </tr>
              </table>
            </div>
          </div>

          <div class="">
            <h2 class="mb-2 text-lg font-bold">แก้ไขสถานะยูนิต</h2>

            <table class="w-full overflow-hidden text-center">
              <tr class="font-bold bg-gray-50">
                <td class="w-1/6 border">Unit</td>
                <td class="w-1/6 border">Default</td>
                <td class="w-1/6 border">Available</td>
                <td class="w-1/6 border">Sold</td>
                <td class="w-1/6 border">Hold</td>
                <td class="w-1/6 border">Disabled</td>
              </tr>
              <tr v-for="unit in units" :key="unit.UnitID">
                <td class="border">{{ unit.UnitNumber }}</td>
                <td class="border"><input v-model="unit._UnitStatus" type="radio" value=""></td>
                <td class="border"><input v-model="unit._UnitStatus" type="radio" value="0"></td>
                <td class="border"><input v-model="unit._UnitStatus" type="radio" value="1"></td>
                <td class="border"><input v-model="unit._UnitStatus" type="radio" value="3"></td>
                <td class="border"><input v-model="unit.disabled" type="checkbox" :checked="unit.disabled"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, watch, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { SettingsIcon, XIcon } from 'vue-tabler-icons'
import OverlayScrollbars from 'overlayscrollbars'

import _ from 'lodash'

export default {
  components: {
    SettingsIcon,
    XIcon,
  },
  setup () {
    const active = ref(false)
    const toggleSettings = (e) => {
      active.value = !active.value
    }

    const store = useStore()

    const showUnitInfo = computed({
      get: () => store.state.setting.showUnitInfo,
      set (value) {
        store.commit('setting/set', {
          key: 'showUnitInfo',
          value: value,
        })
      },
    })

    const showPrice = computed({
      get: () => store.state.setting.showPrice,
      set (value) {
        store.commit('setting/set', {
          key: 'showPrice',
          value: value,
        })
      },
    })

    const units = ref(_.values(_.merge(
      _.keyBy(store.state.unit.units, 'UnitNumber'),
      _.keyBy(store.state.setting.units, 'UnitNumber'),
    )))

    watch(units, (collection, prev) => {
      // const units = collection
      const units = collection.filter(c => c._UnitStatus !== '' || c.disabled)

      store.commit('setting/set', {
        key: 'units',
        value: units.map(unit => _.pick(unit, ['UnitNumber', '_UnitStatus', 'disabled'])),
      })
    }, { deep: true })

    onMounted(() => {
      OverlayScrollbars(document.getElementById('settings'), {
        scrollbars: {
          autoHide: 'move',
        },
      })
    })

    return {
      active,
      toggleSettings,
      showUnitInfo,
      showPrice,
      units,
    }
  },
}
</script>
